import type { TimeDepositState, TimeDepositActions } from "./types";

const INITIAL_STATE: TimeDepositState = {
  loading: false,
  error: false,
  refreshing: false,
  data: {
    timedepositratesvalidity: [],
    pesoTimeDeposit: [],
    longTermPesoTimeDeposit: [],
    longTermPesoTimeDepositFloating: [],
    usdTimeDepositRates: [],
    longTermUsdTimeDepositRates: [],
    rmbDepositRates: [],
    euroTimeDepositRates: [],
    jpyTimeDepositRates: [],
    sgdTimeDepositRates: [],
    audTimeDepositRates: [],
  },
};

export default (
  state: TimeDepositState = INITIAL_STATE,
  action: TimeDepositActions
): TimeDepositState => {
  switch (action.type) {
    case "REQUEST_TIME_DEPOSIT_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
        refreshing: false,
      };
    }
    case "REQUEST_TIME_DEPOSIT_SUCCESS": {
      return {
        loading: false,
        error: false,
        refreshing: false,
        data: action.payload,
      };
    }
    case "REQUEST_TIME_DEPOSIT_FAILED": {
      return {
        ...state,
        loading: false,
        error: false,
        refreshing: false,
      };
    }
    case "REFRESH_TIME_DEPOSIT": {
      return {
        ...state,
        loading: false,
        error: false,
        refreshing: true,
      };
    }
    default:
      return state;
  }
};
